module.exports = __webpack_public_path__ + "img/header-bg.1d84517c.png";